import React from "react"
import TeamLink from "../components/TeamLink"
import TeamCard from "../components/TeamCard"
import Header from "../components/Header"
import Layout from "../layouts/Layout"
import "../styles/global.css"

export default function Team() {
  return (
    <Layout>
      <Header heading="TEAM"></Header>
      <div className="teams-container">
        <TeamCard
          name="Mahendra Salunke"
          position="Faculty Co-ordinator"
          source="/Mahendra_Salunke.png"
        />
        <TeamCard
          name="Abduttayyeb Rampurawala"
          position="Chair"
          source="/Abdul.png"
        />
        <TeamCard
          name="Shruti Jadhav"
          position="Vice Chair"
          source="/Shruti_Jadhav.png"
        />
        <TeamCard
          name="Sreenidhi Bendre"
          position="Web Master"
          source="/Sreenidhi_Bendre.png"
        />
        <TeamCard
          name="Ved Deore"
          position="Web Master"
          source="/Ved_Deore.png"
        />
        <TeamCard
          name="Shovin Kaul"
          position="Web Master"
          source="/Shovin_Kaul.png"
        />
        <TeamCard
          name="Siddhi Thawal"
          position="Design Head"
          source="/Siddhi_Thawal.png"
        />
        <TeamCard
          name="Jui Pangare"
          position="Design Head"
          source="/Jui_Pangare.png"
        />
        <TeamCard
          name="Abhinaysai Kamineni"
          position="Promotional Head"
          source="/Abhinaysai.png"
        />
        <TeamCard
          name="Kaustubh Das"
          position="Secretary"
          source="/Kaustubh_Das.png"
        />
        <TeamCard
          name="Piyush Ingle"
          position="Technical Head"
          source="/Piyush_Ingale.png"
        />
        <TeamCard
          name="Sneha Pujari"
          position="Membership Chair"
          source="/Sneha_Pujari.png"
        />
        <TeamCard
          name="Sarthak Nikhal"
          position="Treasurer"
          source="/Sarthak_Nikhal.png"
        />
      </div>
      <TeamLink
        url="/teams/2020"
        destination="PCCOE&#38;R ACM STUDENT CHAPTER TEAM 2020"
      />
      <div className="seperator"></div>
    </Layout>
  )
}
